module.exports = __webpack_public_path__ + "fromBrideToFather-jp-w.49e568d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-jp-w.jpg
// module id = 5c0y
// module chunks = 0